import { render, staticRenderFns } from "./RegisteredUserAccountSettings.vue?vue&type=template&id=c3b2c8d8&"
import script from "./RegisteredUserAccountSettings.vue?vue&type=script&lang=js&"
export * from "./RegisteredUserAccountSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports